import { useToast } from "@codat/orchard-ui";
import { FileDownload } from "api/schema/insights/spendInsightsCompaniesSchema";
import { useCallback } from "react";

export const useDownloadReportFile = () => {
  const { addToast } = useToast();

  return useCallback(
    async (fileDownload: Promise<FileDownload>) => {
      try {
        const file = await fileDownload;
        const url = window.URL.createObjectURL(file.data as Blob);

        const a = document.createElement("a");
        a.dataset["testid"] = "download-link";
        a.style.display = "none";
        a.href = url;
        a.download = file.fileName;

        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
        addToast({
          variant: "success",
          message: "Your download has started",
        });
      } catch (err) {
        addToast({
          variant: "error",
          message: "Failed to download report",
        });
      }
    },
    [addToast]
  );
};
